;globalThis["_sentryRewritesTunnelPath"] = undefined;globalThis["SENTRY_RELEASE"] = {"id":"d48d0b4efbfcedd7185a235ff10c341886d88a8b"};globalThis["_sentryBasePath"] = undefined;globalThis["_sentryNextJsVersion"] = "15.5.21";globalThis["_sentryRewriteFramesAssetPrefixPath"] = "";globalThis["_sentryAssetPrefix"] = undefined;globalThis["_sentryExperimentalThirdPartyOriginStackFrames"] = undefined;globalThis["_sentryRouteManifest"] = "{\"isrRoutes\":[],\"dynamicRoutes\":[],\"staticRoutes\":[]}";import * as Sentry from '@sentry/nextjs';

import { CUSTOMER_CHAT_HARD_NAVIGATION } from './utils/customerChatTagGuard';
import { redactReviewerLink } from './utils/redactReviewerLink';

// Browser-side Sentry (the `instrumentation-client` convention that @sentry/nextjs
// and Next 15/Turbopack expect; replaces the deprecated sentry.client.config.ts).
// Fully DSN-gated: with NEXT_PUBLIC_SENTRY_DSN unset the SDK is disabled (no network,
// no behavior change), so local/dev is unaffected. NEXT_PUBLIC_* is inlined at build
// time, so this DSN must be set in the build environment (Vercel), not just runtime.
const dsn = process.env.NEXT_PUBLIC_SENTRY_DSN;

Sentry.init({
  dsn,
  enabled: Boolean(dsn),
  // The customer-chat tag guard aborts Next's transition by throwing this on
  // purpose; <Link> leaves the rejection unhandled, so drop it here.
  beforeSend: (event, hint) =>
    hint?.originalException === CUSTOMER_CHAT_HARD_NAVIGATION ? null : redactReviewerLink(event),
  beforeSendTransaction: (event) => redactReviewerLink(event),
  beforeBreadcrumb: (breadcrumb) => redactReviewerLink(breadcrumb),
  // NEXT_PUBLIC_APP_ENV is the deployed discriminator (set in Vercel: local/staging/
  // production). NODE_ENV is 'production' on Vercel staging too, so it must not be the
  // primary source. NEXT_PUBLIC_ENV kept as a fallback for any local usage.
  environment:
    process.env.NEXT_PUBLIC_APP_ENV ||
    process.env.NEXT_PUBLIC_ENV ||
    process.env.NODE_ENV ||
    'development',
  tracesSampleRate: Number(process.env.NEXT_PUBLIC_SENTRY_TRACES_SAMPLE_RATE ?? 0.1),
  // Session Replay intentionally off — this app already ships a heavy client bundle.
  replaysSessionSampleRate: 0,
  replaysOnErrorSampleRate: 0,
});

// Note: Sentry may log an informational "export onRouterTransitionStart" nudge — that
// hook is App-Router client-navigation instrumentation, which doesn't apply to this
// Pages Router app, so it is intentionally omitted. Error capture + tracing are
// unaffected.
